import { ASSETS, BRAND } from '@/lib/brand';
import Reveal from '@/components/Reveal';
import { openCalendly } from '@/lib/calendly';

export default function Founder() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section
      id="about"
      data-testid="founder-section"
      className="relative bg-[#F7F4EE] py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5 relative">
            <Reveal>
              <div className="relative">
                <div className="absolute -top-4 -left-4 w-24 h-24 border-l-2 border-t-2 border-[#B68A35]" />
                <div className="absolute -bottom-4 -right-4 w-24 h-24 border-r-2 border-b-2 border-[#B68A35]" />
                <div className="relative overflow-hidden">
                  <img
                    src={ASSETS.founderHeadshot}
                    alt="Anthony Bowers, Founder & Financial Consultant"
                    className="w-full h-auto aspect-[4/5] object-cover object-center grayscale-[10%] hover:grayscale-0 transition-all duration-[900ms]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0E2238]/25 via-transparent to-transparent" />
                </div>
                <div className="absolute -bottom-8 -right-2 sm:right-6 bg-[#0E2238] px-6 py-4 shadow-xl border border-[#B68A35]/30 max-w-[80%]">
                  <p className="font-serif text-[#D6B36A] text-lg italic">Anthony Bowers</p>
                  <p className="text-white/60 text-[0.7rem] tracking-[0.22em] uppercase mt-1">Founder & Financial Consultant</p>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={140}>
              <div className="overline text-[#B68A35] mb-6">Meet the Founder</div>
            </Reveal>
            <Reveal delay={220}>
              <h2 className="font-serif text-[#0E2238] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-8">
                Personalized Strategy.<br />
                <span className="italic">Purposeful</span> Guidance.
              </h2>
            </Reveal>
            <Reveal delay={320}>
              <p className="text-[#2B2B2B]/80 text-base md:text-lg leading-[1.75] font-light mb-5">
                Your family's financial future deserves more than generic advice.
              </p>
            </Reveal>
            <Reveal delay={400}>
              <p className="text-[#2B2B2B]/80 text-base md:text-lg leading-[1.75] font-light mb-5">
                With a background in education, finance, and leadership, Anthony Bowers helps clients
                simplify complex financial decisions through personalized strategies designed to
                protect today's priorities while building tomorrow's opportunities.
              </p>
            </Reveal>
            <Reveal delay={480}>
              <p className="text-[#2B2B2B]/80 text-base md:text-lg leading-[1.75] font-light mb-10">
                His approach begins with education, moves toward strategy, and always centers on legacy —
                the people, values, and future you are building for.
              </p>
            </Reveal>

            <Reveal delay={560}>
              <div className="flex flex-wrap items-center gap-4">
                <button
                  onClick={openCalendly}
                  data-testid="founder-cta-consult"
                  className="btn-gold"
                >
                  Speak With Anthony
                </button>
                <a
                  href={BRAND.emailHref}
                  data-testid="founder-email-link"
                  className="text-[#0E2238] hover:text-[#B68A35] text-sm tracking-wide underline underline-offset-4 decoration-[#B68A35]/40 hover:decoration-[#B68A35] transition-colors"
                >
                  {BRAND.email}
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
